import modQuery from '../dom-helpers/modQuery';
/**
 * Closes and slides up a target element when a trigger element is clicked.
 * @param {string} triggerSelector - The selector for the trigger element.
 * @param {string} [targetSelector='[data-close-target]'] - The selector for the target element to close and slide up. Default: '[data-close-target]'
 * @example
 * closeAndSlideUp('.close-button'); // Uses default selector to find the closest ancestor with [data-close-target] attribute
 * @example
 * closeAndSlideUp('.close-button', '.custom-target'); // Uses custom selector to find the closest ancestor with "custom-target"
 * @example
 * closeAndSlideUp('.close-button', '[data-custom-attr]'); // custom attribute can be used as a selector
 */
export default function closeAndSlideUp(triggerSelector, targetSelector = '[data-close-target]') {
	const trigger = document.querySelector(triggerSelector);

	if (!trigger) {
		console.warn(`No element found matching selector: ${triggerSelector}`);
		return;
	}

	trigger.addEventListener('click', function() {
		const target = trigger.closest(targetSelector);
		if (!target) {
			console.warn(`No element found matching selector: ${targetSelector}`);
			return;
		}
		if (target) {
			modQuery(target).slideUp();
		}
	});
}
